export default class AppDataImage {
    constructor () {
        this.imageBaseSrc = 'https://source.unsplash.com/{i}/{w}x{h}?{k}';
        this.initAll();
    }

    initAll () {
        let self = this;
        $('[data-image]').each(function () {
            self.init($(this));
        });
    }

    init ($imageContainer) {
        let $imageHolder = $imageContainer.find('.image-holder');
        let isFull = ($imageContainer.data('image') === 'full');
        let imageId = $imageContainer.data('image-id');
        let keyword = $imageContainer.data('keyword');
        let imageSrc = this.imageBaseSrc
            .replace('{w}', isFull ? $(document).width() : $imageHolder.width())
            .replace('{h}', isFull ? $(document).height() : $imageHolder.height())
            .replace('{i}', imageId || (keyword ? 'featured' : 'random'))
            .replace('{k}', keyword || '')
        ;
        $imageHolder.css('background-image', 'url(' + imageSrc + ')');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/dataImage.js